import * as React from 'react';
import { useEffect, useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { ButtonTheme } from '../../enums';
import { UseState } from '../../types';

import { ButtonsContainer, Container, Content, InnerContainer, LogoSection, StyledButton, StyledLogo } from './fullscreenPopup.styled';
import { FullscreenPopupProps } from './fullscreenPopup.types';

export const FullscreenPopup: React.FC<FullscreenPopupProps> = (props: FullscreenPopupProps): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const {
    children,
    isVisible,
    firstButtonAction,
    secondButtonAction,
    firstButtonLabel,
    secondButtonLabel = t('onarte.common.cancel'),
    className
  }: FullscreenPopupProps = props;
  const [isPopupVisible, setIsPopupVisible]: UseState<boolean> = useState<boolean>(isVisible);

  useEffect((): void => setIsPopupVisible(isVisible), [isVisible]);

  return (
    <Container $isVisible={isPopupVisible} data-testid='popup-container' className={className}>
      <LogoSection>
        <StyledLogo />
      </LogoSection>
      <InnerContainer>
        <Content>{children}</Content>
        <ButtonsContainer>
          <StyledButton fullWidth label={firstButtonLabel} onClick={firstButtonAction} />
          <StyledButton
            fullWidth
            buttonTheme={ButtonTheme.GrayTransparent}
            label={secondButtonLabel || ''}
            onClick={secondButtonAction}
          />
        </ButtonsContainer>
      </InnerContainer>
    </Container>
  );
};
